<template>
  <div :class="isDetail ? 'ly-no-data detail' : 'ly-no-data'">
    <p class="text">!! [CA071] !!_QoS work_Check<br><br>
              show run interface GigabitEthernet7/35<br><br>
              show policy-map 300M<br><br>
              ----------Do_not_erase_this_line----------<br><br>
              !! [CA071] !!_QoS work_Rollback<br><br>

              config t<br><br>

              interface GigabitEthernet7/35<br>
              no service-policy input 300M<br>
              service-policy input 100M<br>
              end
    </p>

              




  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.ly-no-data {
  display: flex;
  margin : {
    top: 5px;
    bottom: 5px;
  }
  height: 98%;
  align-items: center;
  justify-content: center;
  background: $--color-white-smoke;
  border-radius: 10px;
  .text {
    width: 325px;
    //line-height: 26px;
    font-size: $--font-size-base;
    color: $--text-nodata;
    text-align: center;
  }
  &.detail {
    height: calc(100vh - 280px);
    
  }
}
</style>
